// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-table .el-table__body-wrapper[data-v-bc487b28] {\n  overflow: auto !important;\n}", ""]);
// Exports
module.exports = exports;
